import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'
import { Page } from '../../Pages'
import { ShowIfRole } from '../../auth/AuthGuard'

const AlertsPage = Loadable(lazy(() => import('./Alerts')))

const AlertsRoutes = [
	{
		path: Page.alerts.path,
		element: (
			<ShowIfRole role={Page.alerts.auth}>
				<AlertsPage />
			</ShowIfRole>
		),
		auth: Page.alerts.auth
	}
]

export default AlertsRoutes
